import { render, staticRenderFns } from "./FormGroupHeading.vue?vue&type=template&id=50b92b30&scoped=true&"
var script = {}
import style0 from "./FormGroupHeading.vue?vue&type=style&index=0&id=50b92b30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b92b30",
  null
  
)

export default component.exports